module.exports = __webpack_public_path__ + "img/ch71.aae27263.png";